class PromotionSlider extends HTMLElement {

  constructor() {
    super();
    this.slider = this.querySelector('[data-slider]');
    if (!this.slider) return;
    this.type = this.getAttribute('type');
    this.slides = this.type === 'dual' ? 2 : 1;
    this.initSlider();
  }

  initSlider() {
    const options = {
      container: this.slider,
      controls: false,
      nav: false,
      items: 1,
      loop: true,
      autoplay: true,
      autoplayButton: false,
      speed: 500,
      responsive: {
        992: {
          items: this.slides,
          slideBy: 1
        }
      }
    };
    tns(options);
  }

}
customElements.define('promotion-slider', PromotionSlider);